import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { loadCbu, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import Cbu from '../components/Cbu.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        verifyCbu(values){
            dispatch(submitForm());
            return dispatch(loadCbu(values)).then((result) => {

                    if (typeof(result.payload.response) !== 'undefined') {
                        if(result.payload.response.status === 400) {
                            dispatch(stopSubmitForm());
                            throw new SubmissionError({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                        }
                    } else {
                        dispatch(getNextStep()).then((result) => {
                            if (typeof(result.payload.data.endpoint) !== "undefined") {
                                sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                                dispatch(stopSubmitForm());
                                browserHistory.push(result.payload.data.endpoint)
                            }
                        });
                    }
                });
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cbu);



/** WEBPACK FOOTER **
 ** ./src/containers/CbuContainer.js
 **/